import { Alpha2 } from "../Alpha2";
import { ar as NameAr } from "./ar";
import { az as NameAz } from "./az";
import { be as NameBe } from "./be";
import { bg as NameBg } from "./bg";
import { bs as NameBs } from "./bs";
import { ca as NameCa } from "./ca";
import { cs as NameCs } from "./cs";
import { da as NameDa } from "./da";
import { de as NameDe } from "./de";
import { el as NameEl } from "./el";
import { en as NameEn } from "./en";
import { es as NameEs } from "./es";
import { et as NameEt } from "./et";
import { fa as NameFa } from "./fa";
import { fi as NameFi } from "./fi";
import { fr as NameFr } from "./fr";
import { he as NameHe } from "./he";
import { hr as NameHr } from "./hr";
import { hu as NameHu } from "./hu";
import { hy as NameHy } from "./hy";
import { id as NameId } from "./id";
import { it as NameIt } from "./it";
import { ja as NameJa } from "./ja";
import { ka as NameKa } from "./ka";
import { kk as NameKk } from "./kk";
import { ko as NameKo } from "./ko";
import { ky as NameKy } from "./ky";
import { lt as NameLt } from "./lt";
import { lv as NameLv } from "./lv";
import { mk as NameMk } from "./mk";
import { mn as NameMn } from "./mn";
import { nb as NameNb } from "./nb";
import { nl as NameNl } from "./nl";
import { nn as NameNn } from "./nn";
import { pl as NamePl } from "./pl";
import { pt as NamePt } from "./pt";
import { ro as NameRo } from "./ro";
import { ru as NameRu } from "./ru";
import { sk as NameSk } from "./sk";
import { sl as NameSl } from "./sl";
import { sr as NameSr } from "./sr";
import { sv as NameSv } from "./sv";
import { tr as NameTr } from "./tr";
import { uk as NameUk } from "./uk";
import { uz as NameUz } from "./uz";
import { zh as NameZh } from "./zh";
export var Name;
(function (Name) {
    function generate(names) {
        return {
            from: (country) => {
                const c = (typeof country == "string" && country.length == 3) || typeof country == "number"
                    ? Alpha2.from(country)
                    : country;
                return c ? names[c] : undefined;
            },
            parse: (country) => {
                return Object.entries(names).find(entry => entry[1].toLowerCase() == country.toLowerCase())?.[0];
            },
        };
    }
    Name.ar = generate(NameAr.names);
    Name.az = generate(NameAz.names);
    Name.be = generate(NameBe.names);
    Name.bg = generate(NameBg.names);
    Name.bs = generate(NameBs.names);
    Name.ca = generate(NameCa.names);
    Name.cs = generate(NameCs.names);
    Name.da = generate(NameDa.names);
    Name.de = generate(NameDe.names);
    Name.el = generate(NameEl.names);
    Name.en = generate(NameEn.names);
    Name.es = generate(NameEs.names);
    Name.et = generate(NameEt.names);
    Name.fa = generate(NameFa.names);
    Name.fi = generate(NameFi.names);
    Name.fr = generate(NameFr.names);
    Name.he = generate(NameHe.names);
    Name.hr = generate(NameHr.names);
    Name.hu = generate(NameHu.names);
    Name.hy = generate(NameHy.names);
    Name.id = generate(NameId.names);
    Name.it = generate(NameIt.names);
    Name.ja = generate(NameJa.names);
    Name.ka = generate(NameKa.names);
    Name.kk = generate(NameKk.names);
    Name.ko = generate(NameKo.names);
    Name.ky = generate(NameKy.names);
    Name.lt = generate(NameLt.names);
    Name.lv = generate(NameLv.names);
    Name.mk = generate(NameMk.names);
    Name.mn = generate(NameMn.names);
    Name.nb = generate(NameNb.names);
    Name.nl = generate(NameNl.names);
    Name.nn = generate(NameNn.names);
    Name.pl = generate(NamePl.names);
    Name.pt = generate(NamePt.names);
    Name.ro = generate(NameRo.names);
    Name.ru = generate(NameRu.names);
    Name.sk = generate(NameSk.names);
    Name.sl = generate(NameSl.names);
    Name.sr = generate(NameSr.names);
    Name.sv = generate(NameSv.names);
    Name.tr = generate(NameTr.names);
    Name.uk = generate(NameUk.names);
    Name.uz = generate(NameUz.names);
    Name.zh = generate(NameZh.names);
    function parse(country) {
        return (Name.ar.parse(country) ??
            Name.az.parse(country) ??
            Name.be.parse(country) ??
            Name.bg.parse(country) ??
            Name.bs.parse(country) ??
            Name.ca.parse(country) ??
            Name.cs.parse(country) ??
            Name.da.parse(country) ??
            Name.de.parse(country) ??
            Name.el.parse(country) ??
            Name.en.parse(country) ??
            Name.es.parse(country) ??
            Name.et.parse(country) ??
            Name.fa.parse(country) ??
            Name.fi.parse(country) ??
            Name.fr.parse(country) ??
            Name.he.parse(country) ??
            Name.hr.parse(country) ??
            Name.hu.parse(country) ??
            Name.hy.parse(country) ??
            Name.id.parse(country) ??
            Name.it.parse(country) ??
            Name.ja.parse(country) ??
            Name.ka.parse(country) ??
            Name.kk.parse(country) ??
            Name.ko.parse(country) ??
            Name.ky.parse(country) ??
            Name.lt.parse(country) ??
            Name.lv.parse(country) ??
            Name.mk.parse(country) ??
            Name.mn.parse(country) ??
            Name.nb.parse(country) ??
            Name.nl.parse(country) ??
            Name.nn.parse(country) ??
            Name.pl.parse(country) ??
            Name.pt.parse(country) ??
            Name.ro.parse(country) ??
            Name.ru.parse(country) ??
            Name.sk.parse(country) ??
            Name.sl.parse(country) ??
            Name.sr.parse(country) ??
            Name.sv.parse(country) ??
            Name.tr.parse(country) ??
            Name.uk.parse(country) ??
            Name.uz.parse(country) ??
            Name.zh.parse(country));
    }
    Name.parse = parse;
    function from(language, country) {
        return {
            ar: Name.ar.from,
            az: Name.az.from,
            be: Name.be.from,
            bg: Name.bg.from,
            bs: Name.bs.from,
            ca: Name.ca.from,
            cs: Name.cs.from,
            da: Name.da.from,
            de: Name.de.from,
            el: Name.el.from,
            en: Name.en.from,
            es: Name.es.from,
            et: Name.et.from,
            fa: Name.fa.from,
            fi: Name.fi.from,
            fr: Name.fr.from,
            he: Name.he.from,
            hr: Name.hr.from,
            hu: Name.hu.from,
            hy: Name.hy.from,
            id: Name.id.from,
            it: Name.it.from,
            ja: Name.ja.from,
            ka: Name.ka.from,
            kk: Name.kk.from,
            ko: Name.ko.from,
            ky: Name.ky.from,
            lt: Name.lt.from,
            lv: Name.lv.from,
            mk: Name.mk.from,
            mn: Name.mn.from,
            nb: Name.nb.from,
            nl: Name.nl.from,
            nn: Name.nn.from,
            pl: Name.pl.from,
            pt: Name.pt.from,
            ro: Name.ro.from,
            ru: Name.ru.from,
            sk: Name.sk.from,
            sl: Name.sl.from,
            sr: Name.sr.from,
            sv: Name.sv.from,
            tr: Name.tr.from,
            uk: Name.uk.from,
            uz: Name.uz.from,
            zh: Name.zh.from,
        }[language](country);
    }
    Name.from = from;
    Name.languages = [
        "ar",
        "az",
        "be",
        "bg",
        "bs",
        "ca",
        "cs",
        "da",
        "de",
        "el",
        "en",
        "es",
        "et",
        "fa",
        "fi",
        "fr",
        "he",
        "hr",
        "hu",
        "hy",
        "id",
        "it",
        "ja",
        "ka",
        "kk",
        "ko",
        "ky",
        "lt",
        "lv",
        "mk",
        "mn",
        "nb",
        "nl",
        "nn",
        "pl",
        "pt",
        "ro",
        "ru",
        "sk",
        "sl",
        "sr",
        "sv",
        "tr",
        "uk",
        "uz",
        "zh",
    ];
})(Name || (Name = {}));
//# sourceMappingURL=index.js.map